module.exports = __webpack_public_path__ + "static/media/discGolf.ede0d8f1.png";